import {Component} from "react"
import {FieldArray, reduxForm} from "redux-form"
import CheckboxToggleList from "../../Form/Field/CheckboxList.jsx"
import FormGlobalErrors from "../../Form/FormGlobalErrors.jsx"

export const name = 'ActivitiesForm'

class ActivitiesForm extends Component {
  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <FieldArray
              id="secteurs"
              name="freelance.secteurs"
              component={CheckboxToggleList}
              customOnChange={() => this.props.submit()}
              disabled={this.props.submitting || this.props.disabled}
            />
          </div>

          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
})(ActivitiesForm)